<script type="text/jsx" lang="jsx">
import Add from './add';
import Edit from './edit';
import EditDelta from './edit-delta.vue';
import BuyNow from './buy-now';
import Trial2paid from './trial2paid';
import planPropsMixin from '@/plans/mx/plan-props';
import planCommonMixin from '@/plans/EVENT_SAAS/mixin';
import Zs2Ze from '@/plans/EVENT_SAAS/config/Zs2Ze.vue';
import { isAutoAddable } from '@/plans/ZOOM_MEETING/common/utils';

export default {
  mixins: [planPropsMixin, planCommonMixin],
  render() {
    const context = {...this.$props, ...this.$attrs};

    if (this.$context.is.add2cart) return <Add {...context} />;
    if (this.$context.is.trial2paid) return <Trial2paid {...context} />;
    if (this.$context.is.edit) {
      if (this.$context.is.addQty && isAutoAddable()) {
        return <EditDelta {...context} />;
      }
      return <Edit {...context} />;
    }
    if (this.$context.is.zs2ze) return <Zs2Ze {...context} />;
    return <BuyNow {...context} />;
  },
};
</script>
